<ngx-ui-loader loaderId="isLoader"></ngx-ui-loader>
<div class="toolbar pt-10 shadow-sm sticky-top" id="kt_toolbar">
<div id="kt_toolbar_container"
    class="container-xxl d-flex justify-content-center justify-content-lg-start align-items-center gap-4">
    <a routerLink="/" class="d-flex align-items-center me-2" *ngIf="!brandDetails?.features?.main_website_url">
        <app-logo-renderer class="h-25px h-lg-40px" ></app-logo-renderer>
    </a>

</div>
</div>

<div id="kt_content_container"
     class="d-flex justify-content-start align-items-start container-xxl mb-10"
     style="min-height: 100vh;">
    <div class="content w-100" id="kt_content">
        <!-- SAN-1479: confirm before anything changes -->
        <div class="card mb-5 mb-xl-8 pt-10 pb-10 d-flex justify-content-center align-items-center" *ngIf="view === 'confirm'">
            <div class="card-header border-0">
                <div class="card-title m-0">
                    <h3 class="fw-bolder m-0">Unsubscribe from emails</h3>
                </div>
            </div>
            <div class="card-body pt-5 d-flex">
                <div class="w-100 text-center">
                    <p>Choose which emails <strong>{{ maskedEmail }}</strong> should stop receiving.</p>
                    <div class="d-inline-flex flex-column align-items-start text-start my-5 gap-4">
                        <label class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" name="unsubscribeScope" value="marketing" [(ngModel)]="scope">
                            <span class="form-check-label">
                                <span class="fw-semibold d-block">Promotional emails only</span>
                                <span class="text-muted fs-7">New opportunities, events, programs and other offers.</span>
                            </span>
                        </label>
                        <label class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" name="unsubscribeScope" value="all" [(ngModel)]="scope">
                            <span class="form-check-label">
                                <span class="fw-semibold d-block">All non-essential emails</span>
                                <span class="text-muted fs-7">Promotions, summaries and activity updates such as connection, meeting and chat emails.</span>
                            </span>
                        </label>
                    </div>
                    <p class="text-muted fs-7">Security and account emails (such as one-time passwords and password resets) are always sent.</p>
                    <button type="button" class="btn btn-primary mt-3" [disabled]="submitting" (click)="confirmUnsubscribe()">Unsubscribe</button>
                </div>
            </div>
        </div>

        <div class="card mb-5 mb-xl-8 pt-10 pb-10 d-flex justify-content-center align-items-center" *ngIf="view === 'done'">
            <div class="card-header border-0">
                <div class="card-title m-0">
                    <h3 class="fw-bolder m-0">Unsubscribe successful</h3>
                </div>
            </div>
            <div class="card-body pt-5 d-flex">
                <div class="w-100 text-center">
                    <p>We're sorry to see you go!</p>
                    <p>You have been unsubscribed. If this was a mistake or if you change your mind, you can always resubscribe through your account settings.</p>
                    <a href="/account/edit/email/notification" class="btn btn-lg btn-light mt-5">Go to Account Settings</a> &nbsp;
                    <a href="/auth/login" class="btn btn-primary mt-5">Go to Home</a>
                </div>
            </div>
        </div>

        <div class="card mb-5 mb-xl-8 pt-10 pb-10 d-flex justify-content-center align-items-center" *ngIf="view === 'invalid'">
            <div class="card-header border-0">
                <div class="card-title m-0">
                    <h3 class="fw-bolder m-0">This link has expired</h3>
                </div>
            </div>
            <div class="card-body pt-5 d-flex">
                <div class="w-100 text-center">
                    <p>This unsubscribe link is no longer valid. Log in to manage which emails you receive.</p>
                    <a href="/account/edit/email/notification" class="btn btn-primary mt-5">Manage email settings</a>
                </div>
            </div>
        </div>
    </div>
</div>
